module.exports = __webpack_public_path__ + "img/frustrated.8369fbdc.gif";